import "../styles/Birthday.css"

import { useEffect, useRef, useState } from "react"

import { generateToast } from "../components/Toast"

function Birthday() {
    const target = new Date(2026, 6, 18, 19, 30, 0, 0)
    const [values, setValues] = useState({ months: 0, days: 0, h: 0, min: 0, s: 0, isPast: true })
    const [modal, setModal] = useState(false)

    const calcDiffToTarget = (now) => {
        if(now >= target) {
            return { months: 0, days: 0, h: 0, min: 0, s: 0, isPast: true }
        }

        let months = (target.getFullYear() - now.getFullYear()) * 12 + (target.getMonth() - now.getMonth())

        const temp = new Date(now.getTime())

        const snap = new Date(temp.getTime())
        snap.setMonth(snap.getMonth() + months)

        if(snap > target) {
            months -= 1;
        }

        const anchor = new Date(temp.getTime())
        anchor.setMonth(anchor.getMonth() + months)

        let remainingMs = target - anchor

        const secondsTotal = Math.floor(remainingMs / 1000);
        const days = Math.floor(secondsTotal / 86400);
        const hours = Math.floor((secondsTotal % 86400) / 3600);
        const minutes = Math.floor((secondsTotal % 3600) / 60);
        const seconds = secondsTotal % 60;

        return { months, days, h: hours, min: minutes, s: seconds, isPast: false }
    }

    useEffect(() => {
        const tick = () => {
            const now = new Date()
            const next = calcDiffToTarget(now)

            setValues(next)
            if(next.isPast) clearInterval(id)
        }

        tick()
        const id = setInterval(tick, 1000)
        return () => clearInterval(id)
    }, [])

    const getNumber = (value, index) => {
        if(index > 2) index = 2
        if(index < 1) index = 1

        const valueToString = String(value)
        let sliced = valueToString.split("")

        if(sliced.length == 1) {
            sliced = ["0", sliced[0]]
        }

        return sliced[index - 1]
    }

    const timeBoxElement = (value, name) => {
        return (
            <>
            <div className="time-box">
                <div className="values-box">
                    <div className="first-value">
                        <span className="text4 keyword2">
                            {getNumber(value, 1)}
                        </span>
                    </div>

                    <div className="second-value">
                        <span className="text4 keyword2">
                            {getNumber(value, 2)}
                        </span>
                    </div>
                </div>

                <div className="indicator">
                    <span className="text3">
                        {name}
                    </span>
                </div>
            </div>
            </>
        )
    }

    return (
        <div className="body body-birthday">
            <div className="content">
                <div className="content-box part1">

                    <span className="text keyword">Kenzo</span>
                    <span className="text">Fête ses</span>
                    <span className="text keyword">20 ans</span>

                </div>

                <div className="content-box part2">

                    <span className="text2">Le</span>
                    <span className="text2 keyword">18 juillet 2026</span>
                    <span className="text2">à</span>
                    <span className="text2 keyword">19h30</span>

                </div>

                <div className="timer">
                    <div className="timer-units large-units">

                        {timeBoxElement(values.months, "Mois")}

                        <div className="time-separator">
                            <span className="text4">:</span>
                        </div>

                        {timeBoxElement(values.days, "Jours")}

                    </div>

                    <div className="timer-units little-units">

                        {timeBoxElement(values.h, "Heures")}

                        <div className="time-separator">
                            <span className="text4">:</span>
                        </div>

                        {timeBoxElement(values.min, "Minutes")}

                        {window.screen.width <= 768 ? (<></>) : (
                            <>
                            <div className="time-separator">
                                <span className="text4">:</span>
                            </div>

                            {timeBoxElement(values.s, "Secondes")}
                            </>
                        )}

                    </div>

                    {window.screen.width <= 768 ? (
                        <>
                        <div className="timer-units seconds-units">
                            {timeBoxElement(values.s, "Secondes")}
                        </div>
                        </>
                    ): (
                        <>
                        </>
                    )}
                </div>

                <button className="birth-button confirm" onClick={(e) => setModal(true)}>
                    Confirmer ma présence
                </button>

                {modal === true ? (
                    <>
                    <Modal onClose={() => setModal(false)} />
                    </>
                ) : (<></>)}
            </div>
        </div>
    )
}

const Modal = ({ onClose }) => {
    const [formData, setFormData] = useState({ firstName: "", lastName: "", phone: "" })
    const [formDataRegister, setFormDataRegister] = useState({ firstName: "", lastName: "", age: "adult" })
    const [list, setList] = useState([])
    const [mainUser, setMainUser] = useState({})
    // const [list, setList] = useState([{firstName: "Kenzo", lastName: "Simon", age: "adult", id: "kenzo_simon"}, {firstName: "Bob", lastName: "Kev", age: "baby", id: "bob_kev"}])

    const [registerMode, setRegisterMode] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault()

        if(formData.firstName.toLowerCase() === "kenzo_register" && formData.lastName.toLowerCase() === "register") {
            setRegisterMode(!registerMode)
            setFormData({ firstName: "", lastName: "", phone: "" })
            return;
        }

        return
    }

    const handleAddMember = (e) => {
        e.preventDefault()

        if(formDataRegister.firstName.toLowerCase() === "kenzo_register" && formDataRegister.lastName.toLowerCase() === "register") {
            setRegisterMode(!registerMode)
            setFormDataRegister({ firstName: "", lastName: "", age: "adult" })
            return;
        }

        const member = {
            firstName: formDataRegister.firstName,
            lastName: formDataRegister.lastName,
            age: formDataRegister.age
        }

        setList((prev) => [...prev, member])

        setFormDataRegister({ firstName: "", lastName: "", age: "adult" })
        return
    }

    const handleValidInvitations = (e) => {
        e.preventDefault()

        fetch(`https://api.kenzo-simon.fr/birthday/register`, {
            method: "POST",
            body: JSON.stringify({
                data: list
            }),
            headers: {
                "Content-Type": "application/json",
                "X-Content-Type-Options": "nosniff",
                "Content-Security-Policy": "default-src 'self'",
            }
        }).then((res) => res.json()).then((data) => {
            setFormDataRegister({ firstName: "", lastName: "", age: "adult" })
            setList([{ firstName: "Ok", lastName: "Ok", age: "Ok" }])

            setTimeout(() => {
                setList([])
            }, 2000)

        }).catch((err) => {
            console.error(err);
            generateToast({
                title: "Une erreur s'est produite !",
                message: "Désolé mais une erreur est survenue. Veuillez réessayer.",
                type: "error"
            })
        })
    }

    const handleSearchFamily = (e) => {
        e.preventDefault()

        if(formData.firstName.toLowerCase() === "kenzo_register" && formData.lastName.toLowerCase() === "register") {
            setRegisterMode(!registerMode)
            setFormData({ firstName: "", lastName: "", phone: "" })
            return;
        }

        fetch(`https://api.kenzo-simon.fr/birthday/get`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Content-Type-Options": "nosniff",
                "Content-Security-Policy": "default-src 'self'",
            },
            body: JSON.stringify({
                data: {
                    firstName: formData.firstName,
                    lastName: formData.lastName
                }
            })
        }).then((res) => res.json()).then((data) => {
            if(data.errorState === true) {
                generateToast({
                    title: "Une erreur s'est produite !",
                    message: data.message,
                    type: "error"
                })

                return
            }

            setMainUser(data.data.user)
            setList([data.data.user, ...data.data.family])
            setFormData({ firstName: "", lastName: "", phone: "" })

            generateToast({
                title: "Membres de la famille récupérés",
                message: "Avant de confirmer, veuillez confirmer. Si vous n'êtes pas responsable d'un des membres. Veuillez cliquer sur la croix à côté de son nom.",
                duration: 1000 * 45,
                type: "success"
            })

        }).catch((err) => {
            console.error(err);
            generateToast({
                title: "Une erreur s'est produite !",
                message: "Désolé mais une erreur est survenue. Veuillez réessayer.",
                type: "error"
            })
        })
    }

    const handleRemoveFromFamily = (member) => {
        setList((prev) => prev.filter((m) => 
            m.id !== member.id
        ))
    }

    const handleChangeAge = (member, newAge) => {
        setList((prev) => 
            prev.map((m) => 
                m.id === member.id ? { ...m, age: newAge } : m
            )
        )
    }

    const handleFinalyConfirmPresence = (e) => {
        e.preventDefault()

        fetch(`https://api.kenzo-simon.fr/birthday/confirm`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Content-Type-Options": "nosniff",
                "Content-Security-Policy": "default-src 'self'",
            },
            body: JSON.stringify({
                data: {
                    user: mainUser,
                    family: list
                }
            })
        }).then((res) => res.json()).then((data) => {
            if(data.errorState === true) {
                generateToast({
                    title: "Une erreur s'est produite !",
                    message: data.message,
                    type: "error"
                })

                return
            }

            setList([])
            setMainUser({})
            setFormData({ firstName: "", lastName: "", phone: "" })

            generateToast({
                title: "Confirmation réussie !",
                message: data.message,
                type: "success"
            })

        }).catch((err) => {
            console.error(err);
            generateToast({
                title: "Une erreur s'est produite !",
                message: "Désolé mais une erreur est survenue. Veuillez réessayer.",
                type: "error"
            })
        })

    }

    return (
        <div className="birth-modal" onClick={onClose}>
            <div className="birth-modal-popup" onClick={(e) => e.stopPropagation()}>
                <div className="birth-modal-header">
                    <h2 className="modal-title">{registerMode ? "Enregistrer des membres" : "Confirmer ma présence"}</h2>
                    <span className="birth-close-icon" onClick={onClose}>
                        <svg className="birth-close-svg" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet">
                            <path d="M0 0 C1.80688477 1.2436676 1.80688477 1.2436676 3.62890625 2.91235352 C4.32483887 3.5490799 5.02077148 4.18580627 5.73779297 4.84182739 C9.95158416 8.86183467 14.0813715 12.96014879 18.1875 17.08984375 C19.13991612 18.04412993 20.09255695 18.99819188 21.04541016 19.95204163 C23.52666925 22.4370797 26.00490791 24.92510796 28.48248291 27.41381836 C31.02162485 29.96327496 33.56367646 32.50982688 36.10546875 35.05664062 C41.07312882 40.03495631 46.03759686 45.01644371 51 50 C54.65095098 48.46340964 56.96217227 46.27424209 59.73681641 43.47436523 C60.19260574 43.01726166 60.64839508 42.56015808 61.11799622 42.08920288 C62.61717771 40.58355212 64.10925528 39.07105536 65.6015625 37.55859375 C66.64429512 36.50958825 67.68754621 35.46109789 68.73129272 34.4131012 C71.47363804 31.65747108 74.2103555 28.8963248 76.94549561 26.13354492 C81.32921521 21.70665244 85.71971741 17.28651157 90.11344528 12.86955452 C91.6480698 11.32469314 93.1792448 9.77647211 94.71011353 8.22789001 C96.1019838 6.82622337 96.1019838 6.82622337 97.52197266 5.39624023 C98.74963852 4.15619484 98.74963852 4.15619484 100.00210571 2.89109802 C103.20192772 -0.13767938 105.61643035 -0.36177788 110.0234375 -0.265625 C112 0 112 0 114.5 1.4375 C116.24884895 4.42511695 116.79983095 6.89342176 116.72412109 10.35519409 C115.07247825 16.38771378 109.46678606 20.60287745 105.0625 24.81640625 C103.93953119 25.92257281 102.81854504 27.03075544 101.69946289 28.14085388 C98.75973966 31.04634057 95.79400534 33.92377843 92.82189941 36.79608154 C89.78946807 39.73616849 86.78259964 42.70215016 83.7734375 45.66601562 C77.87358559 51.46956907 71.9459849 57.24372261 66 63 C67.53659036 66.65095098 69.72575791 68.96217227 72.52563477 71.73681641 C72.98273834 72.19260574 73.43984192 72.64839508 73.91079712 73.11799622 C75.41644788 74.61717771 76.92894464 76.10925528 78.44140625 77.6015625 C79.49041175 78.64429512 80.53890211 79.68754621 81.5868988 80.73129272 C84.34252892 83.47363804 87.1036752 86.2103555 89.86645508 88.94549561 C94.29334756 93.32921521 98.71348843 97.71971741 103.13044548 102.11344528 C104.67530686 103.6480698 106.22352789 105.1792448 107.77210999 106.71011353 C109.17377663 108.1019838 109.17377663 108.1019838 110.60375977 109.52197266 C111.4304567 110.34041656 112.25715363 111.15886047 113.10890198 112.00210571 C116.13767938 115.20192772 116.36177788 117.61643035 116.265625 122.0234375 C116 124 116 124 114.5625 126.5 C111.57488305 128.24884895 109.10657824 128.79983095 105.64480591 128.72412109 C99.61228622 127.07247825 95.39712255 121.46678606 91.18359375 117.0625 C90.07742719 115.93953119 88.96924456 114.81854504 87.85914612 113.69946289 C84.95365943 110.75973966 82.07622157 107.79400534 79.20391846 104.82189941 C76.26383151 101.78946807 73.29784984 98.78259964 70.33398438 95.7734375 C64.53043093 89.87358559 58.75627739 83.9459849 53 78 C49.3051546 79.53938391 47.0430884 81.7659104 44.2824707 84.63330078 C43.82817184 85.10176422 43.37387299 85.57022766 42.9058075 86.05288696 C41.92275308 87.06690617 40.94181068 88.08297628 39.96276283 89.10086441 C38.40881264 90.71291556 36.84566432 92.31546344 35.27909851 93.91525269 C30.82620045 98.46259882 26.37711074 103.01310072 21.96704102 107.60205078 C19.26524857 110.41203339 16.54174322 113.19930082 13.80287743 115.97314072 C12.76642422 117.03117335 11.73819686 118.0973322 10.71871376 119.17172623 C2.78023823 127.52727161 2.78023823 127.52727161 -1.60903931 128.69281006 C-5.26795617 128.77220109 -7.38706153 128.35879325 -10.5625 126.5 C-12.61741233 122.92623942 -13.05655236 119.93356203 -12 116 C-10.7563324 114.19311523 -10.7563324 114.19311523 -9.08764648 112.37109375 C-8.4509201 111.67516113 -7.81419373 110.97922852 -7.15817261 110.26220703 C-3.13816533 106.04841584 0.96014879 101.9186285 5.08984375 97.8125 C6.04412993 96.86008388 6.99819188 95.90744305 7.95204163 94.95458984 C10.4370797 92.47333075 12.92510796 89.99509209 15.41381836 87.51751709 C17.96327496 84.97837515 20.50982688 82.43632354 23.05664062 79.89453125 C28.03495631 74.92687118 33.01644371 69.96240314 38 65 C36.46061609 61.3051546 34.2340896 59.0430884 31.36669922 56.2824707 C30.89823578 55.82817184 30.42977234 55.37387299 29.94711304 54.9058075 C28.93309383 53.92275308 27.91702372 52.94181068 26.89913559 51.96276283 C25.28708444 50.40881264 23.68453656 48.84566432 22.08474731 47.27909851 C17.53740118 42.82620045 12.98689928 38.37711074 8.39794922 33.96704102 C5.58796661 31.26524857 2.80069918 28.54174322 0.02685928 25.80287743 C-1.03117335 24.76642422 -2.0973322 23.73819686 -3.17172623 22.71871376 C-11.52727161 14.78023823 -11.52727161 14.78023823 -12.69281006 10.39096069 C-12.77220109 6.73204383 -12.35879325 4.61293847 -10.5 1.4375 C-6.92623942 -0.61741233 -3.93356203 -1.05655236 0 0 Z "  transform="translate(12,0)"/>
                        </svg>
                    </span>
                </div>

                <div className="birth-modal-body">
                    {registerMode ? (
                        <>
                        <div className="birth-register birth-register-list">
                            {list.length >= 1 ? (
                                <>
                                {list.map((member, index) => (
                                    <>
                                    <div className="birth-register-element" key={index}>
                                        <div className="register-elem-part">
                                            <p className="register-elem-text">{member.firstName}</p>
                                        </div>

                                        <div className="register-elem-part">
                                            <p className="register-elem-text">{member.lastName}</p>
                                        </div>

                                        <div className="register-elem-part">
                                            <p className="register-elem-text">{member.age}</p>
                                        </div>
                                    </div>
                                    </>
                                ))}
                                </>
                            ) : (
                                <>
                                </>
                            )}
                        </div>
                        <div className="birth-register birth-register-form">
                            <form className="birth-form" onSubmit={handleAddMember}>
                                <div className="form-content">
                                    <div className="birth-inputbox">
                                        <label className="birth-label">
                                            Prénom *
                                        </label>

                                        <input 
                                            name="firstName"
                                            className="birth-input"
                                            placeholder="Prénom"
                                            value={formDataRegister.firstName}
                                            onChange={(e) => setFormDataRegister((prev) => ({
                                                ...prev,
                                                firstName: e.target.value
                                            }))}
                                            required
                                        />
                                    </div>

                                    <div className="birth-inputbox">
                                        <label className="birth-label">
                                            Nom *
                                        </label>

                                        <input 
                                            name="firstName"
                                            className="birth-input"
                                            placeholder="Nom"
                                            value={formDataRegister.lastName}
                                            onChange={(e) => setFormDataRegister((prev) => ({
                                                ...prev,
                                                lastName: e.target.value
                                            }))}
                                            required
                                        />
                                    </div>

                                    <div className="birth-inputbox">
                                        <label className="birth-label">
                                            Type : adult, child, baby *
                                        </label>

                                        <input 
                                            name="firstName"
                                            className="birth-input"
                                            placeholder="Prénom"
                                            value={formDataRegister.age}
                                            onChange={(e) => setFormDataRegister((prev) => ({
                                                ...prev,
                                                age: e.target.value
                                            }))}
                                            required
                                        />
                                    </div>
                                </div>

                                <button className="birth-button submitbutton" type="submit">
                                    Ajouter
                                </button>
                                <button className="birth-button submitbutton" type="button" onClick={handleValidInvitations}>
                                    Inviter !
                                </button>
                            </form>
                        </div>
                        </>
                    ) : (
                        <>
                        {list.length <= 0 ? (
                            <>
                            <form className="birth-form" onSubmit={handleSubmit}>
                                <div className="form-content">
                                    <div className="birth-inputbox">
                                        <label className="birth-label">
                                            Prénom *
                                        </label>

                                        <input 
                                            name="firstName"
                                            className="birth-input"
                                            placeholder="Prénom"
                                            value={formData.firstName}
                                            onChange={(e) => setFormData((prev) => ({
                                                ...prev,
                                                firstName: e.target.value
                                            }))}
                                            required
                                        />
                                    </div>

                                    <div className="birth-inputbox">
                                        <label className="birth-label">
                                            Nom *
                                        </label>

                                        <input 
                                            name="lastName"
                                            className="birth-input"
                                            placeholder="Nom"
                                            value={formData.lastName}
                                            onChange={(e) => setFormData((prev) => ({
                                                ...prev,
                                                lastName: e.target.value
                                            }))}
                                            required
                                        />
                                    </div>
                                </div>

                                <button className="birth-button submitbutton" type="submit" onClick={handleSearchFamily}>
                                    Valider
                                </button>
                            </form>
                            </>
                        ) : (
                            <>
                            <div className="birth-confirm-lastpage">
                                <div className="birth-confirm-lastpage-part1 birth-family-list">
                                    {list.map((member, index) => (
                                        <>
                                        <div className="birth-famlist-member" key={member.id}>
                                            <div className="birth-famlist-part1">
                                                <div className="birth-famlist-part1-part1">
                                                    <p className="birth-famlist-field">
                                                        {member.firstName}
                                                    </p>

                                                    <p className="birth-famlist-field">
                                                        {member.lastName}
                                                    </p>
                                                </div>

                                                <div className="birth-famlist-part1-part2">
                                                    <select 
                                                        className="birth-famlist-age-selector"
                                                        value={member.age}
                                                        onChange={(e) => handleChangeAge(member, e.target.value)}
                                                    >
                                                        <option value={"adult"}>Adulte</option>
                                                        <option value={"child"}>Enfant</option>
                                                        <option value={"baby"}>Bébé</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="birth-famlist-part2">
                                                <span className="birth-famlist-remove" onClick={() => handleRemoveFromFamily(member)}>
                                                    <svg className="birth-famlist-remove-icon" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet">
                                                        <path d="M0 0 C1.80688477 1.2436676 1.80688477 1.2436676 3.62890625 2.91235352 C4.32483887 3.5490799 5.02077148 4.18580627 5.73779297 4.84182739 C9.95158416 8.86183467 14.0813715 12.96014879 18.1875 17.08984375 C19.13991612 18.04412993 20.09255695 18.99819188 21.04541016 19.95204163 C23.52666925 22.4370797 26.00490791 24.92510796 28.48248291 27.41381836 C31.02162485 29.96327496 33.56367646 32.50982688 36.10546875 35.05664062 C41.07312882 40.03495631 46.03759686 45.01644371 51 50 C54.65095098 48.46340964 56.96217227 46.27424209 59.73681641 43.47436523 C60.19260574 43.01726166 60.64839508 42.56015808 61.11799622 42.08920288 C62.61717771 40.58355212 64.10925528 39.07105536 65.6015625 37.55859375 C66.64429512 36.50958825 67.68754621 35.46109789 68.73129272 34.4131012 C71.47363804 31.65747108 74.2103555 28.8963248 76.94549561 26.13354492 C81.32921521 21.70665244 85.71971741 17.28651157 90.11344528 12.86955452 C91.6480698 11.32469314 93.1792448 9.77647211 94.71011353 8.22789001 C96.1019838 6.82622337 96.1019838 6.82622337 97.52197266 5.39624023 C98.74963852 4.15619484 98.74963852 4.15619484 100.00210571 2.89109802 C103.20192772 -0.13767938 105.61643035 -0.36177788 110.0234375 -0.265625 C112 0 112 0 114.5 1.4375 C116.24884895 4.42511695 116.79983095 6.89342176 116.72412109 10.35519409 C115.07247825 16.38771378 109.46678606 20.60287745 105.0625 24.81640625 C103.93953119 25.92257281 102.81854504 27.03075544 101.69946289 28.14085388 C98.75973966 31.04634057 95.79400534 33.92377843 92.82189941 36.79608154 C89.78946807 39.73616849 86.78259964 42.70215016 83.7734375 45.66601562 C77.87358559 51.46956907 71.9459849 57.24372261 66 63 C67.53659036 66.65095098 69.72575791 68.96217227 72.52563477 71.73681641 C72.98273834 72.19260574 73.43984192 72.64839508 73.91079712 73.11799622 C75.41644788 74.61717771 76.92894464 76.10925528 78.44140625 77.6015625 C79.49041175 78.64429512 80.53890211 79.68754621 81.5868988 80.73129272 C84.34252892 83.47363804 87.1036752 86.2103555 89.86645508 88.94549561 C94.29334756 93.32921521 98.71348843 97.71971741 103.13044548 102.11344528 C104.67530686 103.6480698 106.22352789 105.1792448 107.77210999 106.71011353 C109.17377663 108.1019838 109.17377663 108.1019838 110.60375977 109.52197266 C111.4304567 110.34041656 112.25715363 111.15886047 113.10890198 112.00210571 C116.13767938 115.20192772 116.36177788 117.61643035 116.265625 122.0234375 C116 124 116 124 114.5625 126.5 C111.57488305 128.24884895 109.10657824 128.79983095 105.64480591 128.72412109 C99.61228622 127.07247825 95.39712255 121.46678606 91.18359375 117.0625 C90.07742719 115.93953119 88.96924456 114.81854504 87.85914612 113.69946289 C84.95365943 110.75973966 82.07622157 107.79400534 79.20391846 104.82189941 C76.26383151 101.78946807 73.29784984 98.78259964 70.33398438 95.7734375 C64.53043093 89.87358559 58.75627739 83.9459849 53 78 C49.3051546 79.53938391 47.0430884 81.7659104 44.2824707 84.63330078 C43.82817184 85.10176422 43.37387299 85.57022766 42.9058075 86.05288696 C41.92275308 87.06690617 40.94181068 88.08297628 39.96276283 89.10086441 C38.40881264 90.71291556 36.84566432 92.31546344 35.27909851 93.91525269 C30.82620045 98.46259882 26.37711074 103.01310072 21.96704102 107.60205078 C19.26524857 110.41203339 16.54174322 113.19930082 13.80287743 115.97314072 C12.76642422 117.03117335 11.73819686 118.0973322 10.71871376 119.17172623 C2.78023823 127.52727161 2.78023823 127.52727161 -1.60903931 128.69281006 C-5.26795617 128.77220109 -7.38706153 128.35879325 -10.5625 126.5 C-12.61741233 122.92623942 -13.05655236 119.93356203 -12 116 C-10.7563324 114.19311523 -10.7563324 114.19311523 -9.08764648 112.37109375 C-8.4509201 111.67516113 -7.81419373 110.97922852 -7.15817261 110.26220703 C-3.13816533 106.04841584 0.96014879 101.9186285 5.08984375 97.8125 C6.04412993 96.86008388 6.99819188 95.90744305 7.95204163 94.95458984 C10.4370797 92.47333075 12.92510796 89.99509209 15.41381836 87.51751709 C17.96327496 84.97837515 20.50982688 82.43632354 23.05664062 79.89453125 C28.03495631 74.92687118 33.01644371 69.96240314 38 65 C36.46061609 61.3051546 34.2340896 59.0430884 31.36669922 56.2824707 C30.89823578 55.82817184 30.42977234 55.37387299 29.94711304 54.9058075 C28.93309383 53.92275308 27.91702372 52.94181068 26.89913559 51.96276283 C25.28708444 50.40881264 23.68453656 48.84566432 22.08474731 47.27909851 C17.53740118 42.82620045 12.98689928 38.37711074 8.39794922 33.96704102 C5.58796661 31.26524857 2.80069918 28.54174322 0.02685928 25.80287743 C-1.03117335 24.76642422 -2.0973322 23.73819686 -3.17172623 22.71871376 C-11.52727161 14.78023823 -11.52727161 14.78023823 -12.69281006 10.39096069 C-12.77220109 6.73204383 -12.35879325 4.61293847 -10.5 1.4375 C-6.92623942 -0.61741233 -3.93356203 -1.05655236 0 0 Z "  transform="translate(12,0)"/>
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>
                                        </>
                                    ))}
                                </div>

                                <div className="birth-confirm-lastpage-part2">
                                    <p className="birth-faq">
                                        <strong className="faq-title">J'ai oublié quelqu'un ?</strong>
                                        <br/>
                                        Oups... Si ton nom n’apparaît pas, c’est sûrement un oubli de ma part.. <em>(j'ai eu galéré faire les invitations)</em>
                                        <br/>
                                        Mais bien sûr que tu es invité(e) !!
                                        <br/>
                                        Il se peut simplement que ton nom n’ait pas été inclus dans le bon groupe. Dans ce cas, actualise la page et renseigne ton prénom et ton nom dans le formulaire.
                                        <br/>
                                        Et si ça ne marche toujours pas tu peux me contacter directement par SMS à <strong>06 63 05 47 54</strong> ou par e-mail : <a className="birth-fam-link" href="mailto:kenzosimontinti@icloud.com">kenzosimontinti@icloud.com</a> <i>ou un pigeon voyageur ça fonctionne aussi</i>

                                        <br/><br/>
                                        <strong className="faq-title">Une personne apparaît comme étant dans mon groupe mais je ne suis pas responsable de sa présence ?</strong>
                                        <br/>
                                        Pas de soucis j'ai tout prévu ! Clique simplement sur la croix qui apparaît dans la même ligne que son nom. Ensuite elle devra confirmer par elle même par tout autre moyens.

                                        <br/><br/>
                                        <strong className="faq-title">Une erreur s'est produite ?</strong>
                                        <br/>
                                        Ça c'est con... J'ai codé le site un peu à l'arrache honnêtement. Si jamais l'erreur persiste vraiment envoie moi un SMS à <strong>06 63 05 47 54</strong> ou un e-mail : <a className="birth-fam-link" href="mailto:kenzosimontinti@icloud.com">kenzosimontinti@icloud.com</a>
                                    </p>
                                </div>

                                <div className="birth-confirm-lastpage-part3">
                                    <button className="birth-button submitbutton" type="submit" onClick={handleFinalyConfirmPresence}>
                                        Je confirme !
                                    </button>
                                </div>
                            </div>
                            </>
                        )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Birthday